import { render, staticRenderFns } from "./Quacks.vue?vue&type=template&id=5da6b94e"
import script from "./Quacks.vue?vue&type=script&lang=js"
export * from "./Quacks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports